
((c, l, a, r, i) => {
  // Queue stub: any clarity(...) calls before the tag loads are buffered and replayed.
  c[a] =
    c[a] ||
    function () {
      (c[a].q = c[a].q || []).push(arguments);
    };

  const events = ['scroll', 'pointerdown', 'keydown', 'touchstart', 'mousemove'];
  let loaded = false;

  const removeListeners = () => {
    events.forEach((e) => window.removeEventListener(e, loadClarity, { passive: true }));
  };

  const loadClarity = () => {
    if (loaded) return;
    loaded = true;
    const t = l.createElement(r);
    t.async = 1;
    t.src = `https://www.clarity.ms/tag/${i}`;
    const y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
    removeListeners();
  };

  events.forEach((e) => window.addEventListener(e, loadClarity, { passive: true, once: true }));

  // Fallback so it still loads without interaction (idle, then a hard cap).
  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadClarity, { timeout: 5000 });
  } else {
    window.addEventListener('load', () => setTimeout(loadClarity, 3000));
  }


  const getCookie = (name) => {
    const row = document.cookie.split('; ').find((r) => r.startsWith(name + '='));
    return row ? row.slice(name.length + 1) : '';
  };

  const tagged = {};
  const tagOnce = (key, value) => {
    if (!value || tagged[key]) return;
    tagged[key] = true;
    c[a]('set', key, String(value));
  };

  let abTries = 0;
  const tagAbSession = () => {
    try {
      tagOnce('ab_session_id', decodeURIComponent(getCookie('ab_session_id') || ''));
      tagOnce('ab_user_id', decodeURIComponent(getCookie('ab_user_id') || ''));

      let raw = getCookie('ab_active_tests');
      if (raw) raw = decodeURIComponent(raw);
      if (!raw) {
        try {
          raw = localStorage.getItem('ab_active_tests') || '';
        } catch (_) {
          /* storage blocked */
        }
      }
      if (raw) {
        const tests = JSON.parse(raw);
        Object.keys(tests || {}).forEach((id) => {
          const t = tests[id];
          const variant = t && typeof t === 'object' ? t.variant : t;
          tagOnce('ab_' + id, variant);
        });
      }
     
      if (tagged.ab_session_id && raw) return;
    } catch (_) {
      /* tagging must never break the page */
    }
    abTries += 1;
    if (abTries < 10) setTimeout(tagAbSession, 3000);
  };
  tagAbSession();
})(window, document, 'clarity', 'script', 'rpowqzjlz4');
